import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  COURSE_LIST_GET,
  COURSE_CATEGORIES_GET,
  COURSE_LIST_RESET,
  MODULE_LIST_GET,
  CATALOGS_GET,
  LEVELS_GET,
  FFOO_GET,
  GLOBAL_COURSE_LIST_GET,
  GLOBAL_COURSE_CATEGORIES_GET,
  EVENT_LIST_GET,
  COURSE_CATEGORIES_RESET,
} from '../actions/courselist';

const initialState = {
  catalogs: [],
  categories: [],
  categoriesAll: [],
  globalCategories: [],
  levels: [],
  ffoo: [],
  courses: {
    filters: {},
    list: [],
    pager: {},
  },
  modules: {
    filters: {},
    list: [],
    pager: {},
  },
  events: {
    filters: {},
    list: [],
    pager: {},
  },
};

const courselistReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case CATALOGS_GET._SUCCESS: {
        const { response } = action;
        draft.catalogs = response || [];
        break;
      }

      case COURSE_CATEGORIES_RESET: {
        draft.categories = initialState.categories;
        draft.globalCategories = initialState.globalCategories;
        break;
      }
      case COURSE_CATEGORIES_GET._SUCCESS: {
        const { response, filters } = action;
        if (filters?.show_all) draft.categoriesAll = response;
        else draft.categories = response;
        break;
      }

      case GLOBAL_COURSE_CATEGORIES_GET._SUCCESS: {
        const { response } = action;
        draft.globalCategories = response;
        break;
      }

      case LEVELS_GET._SUCCESS: {
        const { response } = action;
        draft.levels = response || [];
        break;
      }

      case FFOO_GET._SUCCESS: {
        const { response } = action;
        draft.ffoo = response || [];
        break;
      }

      case COURSE_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.courses.filters = {
          ...state.courses.filters,
          ...(data?.filters || {}),
        };
        draft.courses.list = data?.items || [];
        draft.courses.pager = pager;
        break;
      }

      case MODULE_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.modules.filters = {
          ...state.modules.filters,
          ...(data?.filters || {}),
        };
        draft.modules.list = data?.items || [];
        draft.modules.pager = pager;
        break;
      }

      case EVENT_LIST_GET._SUCCESS: {
        const { data, pager } = action;
        draft.events.filters = {
          ...state.events.filters,
          ...(data?.filters || {}),
        };
        draft.events.list = data?.items || [];
        draft.events.pager = pager;
        break;
      }

      case COURSE_LIST_RESET: {
        draft = initialState;
        break;
      }

      case GLOBAL_COURSE_LIST_GET._SUCCESS: {
        const { data, pager, isModule } = action;
        if (isModule) {
          draft.modules.filters = {
            ...state.modules.filters,
            ...(data?.filters || {}),
          };
          draft.modules.list = data?.items || [];
          draft.modules.pager = pager;
          break;
        } else {
          draft.courses.filters = {
            ...state.courses.filters,
            ...(data?.filters || {}),
          };
          draft.courses.list = data?.items || [];
          draft.courses.pager = pager;
          break;
        }
      }

      default:
        return state;
    }
    return draft;
  });

export default courselistReducer;
